import { render, staticRenderFns } from "./DuplicateExpedientDialogComponent.vue?vue&type=template&id=3e822a76&scoped=true"
import script from "./DuplicateExpedientDialogComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./DuplicateExpedientDialogComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DuplicateExpedientDialogComponent.vue?vue&type=style&index=0&id=3e822a76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e822a76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e822a76')) {
      api.createRecord('3e822a76', component.options)
    } else {
      api.reload('3e822a76', component.options)
    }
    module.hot.accept("./DuplicateExpedientDialogComponent.vue?vue&type=template&id=3e822a76&scoped=true", function () {
      api.rerender('3e822a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/DuplicateExpedientDialogComponent.vue"
export default component.exports